import React, { useEffect, useState } from "react";
import adminLogo from "../../assets/Images/login.png";
import eslogo from "../../assets/Images/ES-new-Logo.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import { updateStore } from "../../utils/store";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [inputFocus, setInputFocus] = useState<{
    email: boolean;
    password: boolean;
  }>({
    email: false,
    password: false,
  });
  const [state, setState] = useState({
    email: "",
    password: "",
  });
  const [errState, setErrState] = useState<boolean>(false);
  const [stateErr, setStateErr] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  const doLogin = () => {
    if (state.email === "" || state.password === "") {
      setErrState(true);
      setStateErr("Fields required!");
    } else {
      setIsLoading(true);
      setErrState(false);
      axios
        .post(`${process.env.REACT_APP_API_BASEURL}/auth/login`, {
          email: state.email,
          password: state.password,
        })
        .then((response) => {
          if (response.status === 200) {
            updateStore("isAdmin", "true");
            response.data?.accessToken &&
              updateStore("token", window.btoa(response.data?.accessToken));
            response.data?.refreshToken &&
              updateStore(
                "refreshToken",
                window.btoa(response.data?.refreshToken)
              );
            setIsLoading(false);
            navigate("/users/list");
          }
        })
        .catch((err: any) => {
          setErrState(true);
          setStateErr(err?.response?.data?.message as string);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setErrState(false);
    }, 5000);
  }, [errState]);

  return (
    <>
      <div className="w-full h-screen flex items-center justify-center transition-all duration-300 ease-in-out font-mono">
        {isLoading ? <Loader /> : null}
        <div className="lg:w-[80%] lg:h-[90%] md:w-3/4 w-full h-full lg:flex items-center shadow-lg rounded-md border border-[#fcfafa] bg-white">
          <div className="w-full lg:w-1/2 relative">
            <img
              alt="Excelsoft logo"
              src={eslogo}
              className="lg:h-16 h-12 absolute left-2 top-4 lg:top-0"
            />
            <img
              src={adminLogo}
              className="hidden lg:block"
              alt="Excelsoft logo"
            />
          </div>
          <div className=" w-full lg:w-1/2 lg:p-20 p-8">
            {/* <div className="text-right lg:mb-16 mb-10">
              New Users?{" "}
              <span className="text-blue-500" aria-label="SignUp" tabIndex={0}>
                SignUp
              </span>
            </div> */}

            <div
              aria-label="Admin login"
              className="mb-4 font-semibold text-white flex justify-center"
            >
              <div
                className="bg-gray-400 w-fit text-center py-2 px-8 shadow-md"
                style={{ borderRadius: "100px 0px 100px 0px" }}
              >
                {" "}
                Admin Login
              </div>
            </div>
            <div className="mb-8">
              <div className="text-black lg:text-[30px] text-[25px] lg font-bold">
                Welcome Back!
              </div>
              <div className="text-gray-400 pl-1 text-md">
                Login to continue
              </div>
            </div>

            <div className="relative mb-4">
              <input
                type="email"
                value={state.email}
                onChange={(e: any) =>
                  setState({ ...state, email: e.target.value })
                }
                onFocus={() => setInputFocus({ ...inputFocus, email: true })}
                onBlur={() => setInputFocus({ ...inputFocus, email: false })}
                className="relative border lg:h-12 h-10  text-sm w-full outline-none pl-9 focus:border-[#6534D9] focus:border-2 rounded-sm"
                placeholder="username@gmail.com"
              />
              <i
                className={`fa-solid fa-user absolute left-3 top-4 ${
                  inputFocus.email ? `text-[#6534D9]` : `text-gray-500`
                }`}
              ></i>
            </div>
            <div className="relative mb-4">
              <input
                type="password"
                value={state.password}
                onChange={(e: any) =>
                  setState({ ...state, password: e.target.value })
                }
                onFocus={() => setInputFocus({ ...inputFocus, password: true })}
                onBlur={() => setInputFocus({ ...inputFocus, password: false })}
                className="relative border lg:h-12 h-10  text-sm w-full outline-none pl-9 focus:border-[#6534D9] focus:border-2 rounded-sm"
                placeholder="***********"
              />
              <i
                className={`fa-solid fa-lock absolute left-3 top-4 ${
                  inputFocus.password ? `text-[#6534D9]` : `text-gray-500`
                }`}
              ></i>
            </div>

            <div
              onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
                if (event.key === "Enter" || event.code == "Space") {
                  doLogin();
                }
              }}
              onClick={doLogin}
              tabIndex={0}
              className="bg-[#6534D9] border lg:h-12 h-10 w-full outline-none flex items-center justify-center cursor-pointer rounded-md mb-2 focus:border-[#6534D9]"
            >
              <div className="text-white font-semibold">Login</div>
            </div>

            {/* <div className="text-gray-500 text-sm">
              Forgot password?
              <span className="text-blue-500" tabIndex={0}>
                {" "}
                Click here
              </span>{" "}
            </div> */}
            <div className="text-sm text-gray-400 absolute right-0 bottom-0">
              Copyright <i className="fa-regular fa-copyright"></i> 2024
              Excelsoft Technology Pvt Ltd.
            </div>
          </div>
        </div>
      </div>
      {errState && (
        <div className="fixed min-w-[400px] h-[40px] rounded-sm border border-red-500 bg-[#fae1e1] top-[22%] left-[50%] mt-[-100px] ml-[-200px] shadow-md">
          <div className=" text-red-500 flex items-center justify-between h-full pl-2 pr-4">
            <div>
              <span className="px-2">
                <i className="fa-solid fa-triangle-exclamation"></i>
              </span>

              {stateErr}
            </div>
            <div onClick={() => setErrState(false)}>
              {" "}
              <i className="fa-solid fa-xmark cursor-pointer"></i>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminLogin;
